import { Component, HostListener, EventEmitter, Output, TemplateRef, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, Params, ActivatedRoute } from "@angular/router";
import { HttpClient, HttpClientModule, HttpHeaders } from "@angular/common/http";
import { RouterModule } from '@angular/router';
import { FormsModule } from "@angular/forms";
import { FilterPipeModule } from 'ngx-filter-pipe';
import { Ng2SearchPipeModule } from '@ngx-maintenance/ng2-search-filter';
import { NgPipesModule } from 'ngx-pipes';
import { ApidataService } from "../apidata.service";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { DictionaryComponent } from '../dictionary/dictionary.component';
import { LanguageComponent } from '../language/language.component';
import { SavefileComponent } from '../savefile/savefile.component';
import { DownloadComponent } from '../download/download.component';
import { ShareComponent } from '../share/share.component';
import { ComposeEmailComponent } from '../compose-email/compose-email.component';
import { UploadComponent } from '../upload/upload.component';
import { LogoutComponent } from '../logout/logout.component';

import swal from "sweetalert2";
import { SupportComponent } from '../support/support.component';
import { environment, GINConstants } from '../../environments/environments';
declare var $: any;
declare var Dropbox: any;
declare var gapi: any;
declare var google: any;
declare var FB: any;
declare var window: any;
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, HttpClientModule, RouterModule, NgPipesModule,
    FilterPipeModule,
    Ng2SearchPipeModule,
    FormsModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent {
  activeItem: string | null;
  public href: string = "";
  profile_id = "";
  public loaderAlert: boolean = false;
  isUserLoggedin: boolean = false;

  isPopupVisibleforLogin = false;
  public doc_id = "";
  documentId: string;
  closeResult = '';
  isModalOpen = false;
  authentication_token;
  user;
  idgoogle;
  lastName = "";
  firstName = "";
  model: any = {};
  comefromsite: boolean = false;
  isPopupVisible = false;
  visibleforsave: boolean = false;
  lodershow: boolean = false;

  
  @ViewChild("fileInputs") fileInputs;
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

  constructor(private router: Router, private apirequest: ApidataService, private route: ActivatedRoute, private modalService: NgbModal, private el: ElementRef,

  ) {
    this.setActiveFromRoute();
  }
  @Output() iconClicked = new EventEmitter<string>();
  @Output() requestShowPopup = new EventEmitter<void>();
  onIconClick(icon: string) {
    this.iconClicked.emit(icon);
 
  }



  openSidebar() {
    const elements = document.querySelectorAll('.main-menu');
    elements.forEach(element => {
      element.classList.add('no-hover');
    });
    const sidebar = document.getElementById("side-bar");
    if (sidebar) {
      sidebar.style.width = "320px";

    }
  }
  closeSidebr() {
    const elements = document.querySelectorAll('.main-menu');
    elements.forEach(element => {
      element.classList.remove('no-hover');
    });
    const sidebar = document.getElementById("side-bar");
    if (sidebar) {
      sidebar.style.width = "0px";
    }

  }

  loadData(doc_id: string | null): void {
    if (doc_id) {

    }
  }

  ngOnInit() {


    this.route.paramMap.subscribe(params => {
      this.doc_id = params.get('doc_id');
     

      this.loadData(this.doc_id);
    });







    ///// get user profile id
    this.profile_id = localStorage.getItem("profile_id");
    if (!this.profile_id) {
      this.profile_id = '1';
      this.isUserLoggedin = false;
    }
    else {
      this.isUserLoggedin = true;
    }
 
    const fullPath = this.route.snapshot.url.join('/');
  
    this.doc_id = fullPath.split('/')[1]

    this.openModal();
    this.removeBackdrop();
  }

  removeBackdrop() {
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove(); 
    }
  }
  @ViewChild('content', { static: true }) content: TemplateRef<any>;



  open(content) {
    this.modalService.open(content,
      { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult =
          `Dismissed ${this.getDismissReason(reason)}`;
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }






  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  @HostListener('window:click', ['$event'])
  onWindowClick(event: Event) {
    const modal = document.getElementById('myModal');
    if (event.target === modal) {
      this.closeModal();
    }
  }

  openNav() {



    document.getElementById("mySidenav").style.display = "block";
    const sidebar = document.getElementById("mySidenav");
    if (sidebar) {
      sidebar.style.width = "290px";
    }

  
    const elements = document.querySelectorAll('.main-menu');
    elements.forEach(element => {
      element.classList.add('no-hover');
    });


    const mainContent = document.getElementById("main");
    if (mainContent) {
      mainContent.style.marginLeft = "290px";
    }

    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
  }

  closeNav() {

   
    document.getElementById("mySidenav").style.display = "none";
    const sidebar = document.getElementById("mySidenav");
    if (sidebar) {
      sidebar.style.width = "0px";
    }


    const elements = document.querySelectorAll('.main-menu');
    elements.forEach(element => {
      element.classList.remove('no-hover');
    });


    const mainContent = document.getElementById("main");
    if (mainContent) {
      mainContent.style.marginLeft = "0";
    }
    document.body.style.backgroundColor = "initial";
  }



  setActiveFromRoute() {
    const currentRoute = this.router.url; 
    if (currentRoute.includes('document')) {
      this.activeItem = 'document';
    } else if (currentRoute.includes('plagiarismchecker')) {
      this.activeItem = 'plagiarismchecker';
    } else if (currentRoute.includes('paraphrasing')) {
      this.activeItem = 'paraphrasing';
    } else if (currentRoute.includes('article')) {
      this.activeItem = 'article';
    } else if (currentRoute.includes('summarizer')) {
      this.activeItem = 'summarizer';
    }
  }


  setActive(event: MouseEvent, item: string) {
    event.preventDefault();
    this.activeItem = item;

  }


  closePopup() {
    this.isPopupVisibleforLogin = false;
  }


  onSidebarIconClick() {
    if (!this.isPopupVisibleforLogin) {
      this.requestShowPopup.emit(); 
    }
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove(); 
    }
  }
  ///// open new file
  saveTextRedirect(type) {
   
    let data2 = JSON.stringify({ homeText: '', profile_id: this.profile_id });
    let url = environment.API_URL+'/api/getNewDocIDForGuestByContents';
    this.apirequest.postResources(data2, url)
      .subscribe(data => {
        let receivedData = data;
       
        this.doc_id = receivedData['new_doc_id'];
        // this.router.navigate(['/document/', this.doc_id]);
        this.router.navigate(['/grammar-check'], { queryParams: { doc: this.doc_id } });
        $('#mm').text('')
      });
    this.loaderAlert = false;
  }
  navigatetogrammar() {
 
    if (this.doc_id) {
   

      this.router.navigate(['/grammar-check'], { queryParams: { doc: this.doc_id } }).then(() => {
        window.location.reload();
      });
    } else {
      // console.error('doc_id is undefined!');
    }
 
  }
  navigatetohome() {

    this.router.navigate(['/'])
  }
  navigatetoplagifnotloggedin() {

    var editortxt = '';
    editortxt = document.getElementById('mm').textContent;
    localStorage.setItem('editorValueAI', editortxt);
    const url = this.router.serializeUrl(this.router.createUrlTree(['/plagiarism-checker']));
    window.open(url, '_blank');
  }
  navigatetoparapharsingnotloggedin() {
    var editortxt = '';
    editortxt = document.getElementById('mm').textContent;
    localStorage.setItem('editorValueAI', editortxt);
    const url = this.router.serializeUrl(this.router.createUrlTree(['/paraphrasing-tool']));
    window.open(url, '_blank');

  }
  navigatetoarticlenotloggedin() {
    var editortxt = '';
    editortxt = document.getElementById('mm').textContent;
    localStorage.setItem('editorValueAI', editortxt);
    const url = this.router.serializeUrl(this.router.createUrlTree(['/article-rewriter']));
    window.open(url, '_blank');
  }
  navigatetotextnotloggedin() {
    var editortxt = '';
    editortxt = document.getElementById('mm').textContent;
    localStorage.setItem('editorValueAI', editortxt);
    const url = this.router.serializeUrl(this.router.createUrlTree(['/text-summarizer']));
    window.open(url, '_blank');
  }




  navigatetoplag(){
    const mmElement = document.getElementById('mm');
    const editorElement = document.getElementById('editor');

    const mmText = mmElement?.textContent?.trim() || '';
    const editorText = editorElement?.textContent?.trim() || '';


    const textToStore = mmText || editorText;

    if (textToStore) {
      localStorage.setItem('editorValueAI', textToStore);
      const url = this.router.serializeUrl(this.router.createUrlTree(['/plagiarismchecker/', this.doc_id]));
      window.open(url, '_blank')
    } else {
    
      const url = this.router.serializeUrl(this.router.createUrlTree(['/plagiarismchecker/', this.doc_id]));
      window.open(url, '_blank')
    }
  }



  navigatetoparapharsing(){
    const mmElement = document.getElementById('mm');
    const editorElement = document.getElementById('editor');

    const mmText = mmElement?.textContent?.trim() || '';
    const editorText = editorElement?.textContent?.trim() || '';


    const textToStore = mmText || editorText;

    if (textToStore) {
      localStorage.setItem('editorValueAI', textToStore);
      const url = this.router.serializeUrl(this.router.createUrlTree(['/paraphrasing'], { queryParams: { doc: this.doc_id } }));
      window.open(url, '_blank')
    } else {
     
      const url = this.router.serializeUrl(this.router.createUrlTree(['/paraphrasing'], { queryParams: { doc: this.doc_id } }));
      window.open(url, '_blank')
    }
  }




  navigatetotext(){
    const mmElement = document.getElementById('mm');
    const editorElement = document.getElementById('editor');

    const mmText = mmElement?.textContent?.trim() || '';
    const editorText = editorElement?.textContent?.trim() || '';


    const textToStore = mmText || editorText;

    if (textToStore) {
      localStorage.setItem('editorValueAI', textToStore);
      const url = this.router.serializeUrl(this.router.createUrlTree(['/textsummarizer'], { queryParams: { doc: this.doc_id } }));
      window.open(url, '_blank')
    } else {
     
      const url = this.router.serializeUrl(this.router.createUrlTree(['/textsummarizer'], { queryParams: { doc: this.doc_id } }));
      window.open(url, '_blank')
    }
  }

  navigatetoai() {
    this.router.navigate(['/aitext/', this.doc_id]);

  }



  navigatetoarticle(){
    const mmElement = document.getElementById('mm');
    const editorElement = document.getElementById('editor');

    const mmText = mmElement?.textContent?.trim() || '';
    const editorText = editorElement?.textContent?.trim() || '';


    const textToStore = mmText || editorText;

    if (textToStore) {
      localStorage.setItem('editorValueAI', textToStore);
      const url = this.router.serializeUrl(this.router.createUrlTree(['/article'], { queryParams: { doc: this.doc_id } }));
      window.open(url, '_blank');
    } else {
   
      const url = this.router.serializeUrl(this.router.createUrlTree(['/article'], { queryParams: { doc: this.doc_id } }));
      window.open(url, '_blank');
    }
  }


  logout() {
    localStorage.clear()
    this.router.navigate([''])
  }



  navigatetoopenfile() {
    localStorage.setItem('previousdoc', JSON.stringify(this.doc_id));

    this.router.navigate(['/openfile']).then(() => {
      window.location.reload(); 
    });
  }

  navigatetoaccount() {
 
    const url = this.router.serializeUrl(this.router.createUrlTree(['/accountsettings']));
    window.open(url, '_blank');
  }

  navigatetohelpcenter() {
    this.router.navigate(['/help-center']);
  }
  isExpanded: boolean = false;

 
  expandMenu() {
    this.isExpanded = true;
  }


  collapseMenu() {
    this.isExpanded = false;
  }
  toggleSidebar() {
    this.isExpanded = !this.isExpanded; 
  }
  navigatetoSignin() {

    this.router.navigate(['/signin'])
  }
  navigatetoSignUp() {

    this.router.navigate(['/signup'])
  }
  navigatetodictionary() {

    this.router.navigate(['/dictionary'])
  }
  @ViewChild('openButton') openButton: ElementRef;  
  openDictionary() {
 


    const modalRef = this.modalService.open(DictionaryComponent, { ariaLabelledBy: 'modal-basic-title' });
    modalRef.componentInstance.reloadData();

  }

  openLanguage() {
    this.modalService.open(LanguageComponent, { ariaLabelledBy: 'modal-basic-title' });
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove(); 
    }
  }

  opensaveFile() {
    this.modalService.open(SavefileComponent, { ariaLabelledBy: 'modal-basic-title' });
  }

  openDownload() {
    this.modalService.open(DownloadComponent, { ariaLabelledBy: 'modal-basic-title' });
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove(); 
    }
  }
  openLogout() {
    this.modalService.open(LogoutComponent, { ariaLabelledBy: 'modal-basic-title' });
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove(); 
    }
  }
  openShare() {
    this.modalService.open(ShareComponent, { ariaLabelledBy: 'modal-basic-title' });
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove(); 
    }
  }
  openSupport() {
    this.modalService.open(SupportComponent, { ariaLabelledBy: 'modal-basic-title' });
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove(); 
    }
  }
  openComposeEmail() {
    this.modalService.open(ComposeEmailComponent, { ariaLabelledBy: 'modal-basic-title' });
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove(); 
    }
  }
  openUpload() {
    this.modalService.open(UploadComponent, { ariaLabelledBy: 'modal-basic-title' });
  }

  isModalVisible: boolean = false;
  @ViewChild('homeButtonModal') homeButtonModal: ElementRef;
  ngAfterViewInit() {


    $(document).ready(function () {
    
      const sidebar = document.getElementById("side-bar");
 
      $('.menu-btns').click(function () {
        $('.side-bar').addClass('active');
     
      });

      $('.close-btn').click(function () {
        $('.side-bar').removeClass('active');
       
      });

    });






    const modalElement = this.el.nativeElement.querySelector('#homeButtonModal');

    $(modalElement).on('shown.bs.modal', function () {

      $('.modal-backdrop').remove();
    });

    $(modalElement).on('hidden.bs.modal', function () {

      $('.modal-backdrop').remove();
    });
  }

  openHomeButtonModal() {
    const modalElement = document.getElementById('homeButtonModal');
    if (modalElement) {
      modalElement.classList.add('show');
      modalElement.style.display = 'block';
      modalElement.setAttribute('aria-hidden', 'false');
      modalElement.setAttribute('aria-modal', 'true');
      document.body.classList.add('modal-open'); 


      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove(); 
      }
    }
  }
  closeHomeButtonModal() {
    const modalElement = document.getElementById('homeButtonModal');
    if (modalElement) {
      modalElement.classList.remove('show');
      modalElement.style.display = 'none';
      modalElement.setAttribute('aria-hidden', 'true');
      modalElement.setAttribute('aria-modal', 'false');
      document.querySelector('.modal-backdrop')?.remove();
    }
  }
  private initializeGoogleAuth(): Promise<void> {
    return new Promise((resolve, reject) => {
      gapi.load('auth2', () => {
        gapi.auth2.init({
          client_id: '859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com',  
        }).then(() => {
          resolve();
        }).catch((error) => {
          // console.error('Error initializing Google Auth', error);
          reject(error);
        });
      });
    });
  }
  public googleLogin(): void {
    this.initializeGoogleAuth().then(() => {
      const googleAuth = gapi.auth2.getAuthInstance();
      googleAuth.signIn({ scope: 'profile email' }).then(googleUser => {

        this.onSignIn(googleUser);
      }).catch(error => {
        // console.error('Google Sign-In failed', error);
      });
    }).catch(error => {
      // console.error('Google API initialization failed', error);
    });
  }

  public onSignIn(googleUser): void {
    const profile = googleUser.getBasicProfile();
    const id_token = googleUser.getAuthResponse().id_token;
    const body = {
      firstname: btoa(profile.getGivenName()),
      lastname: btoa(profile.getFamilyName()),
      email: btoa(profile.getEmail())
    };


    this.gLogin(body);
  }
  public gLogin(body): void {
    this.apirequest.signupinGoogle2(body).subscribe(data => {
      if (data.meta.code === 200) {
        localStorage.setItem('currentUser', JSON.stringify(data));
   
        this.user = data['response'];
        this.authentication_token = this.user['user'].authentication_token;
        this.idgoogle = this.user['user'].id;
        localStorage.setItem('fullname', this.user['user'].verify)
        localStorage.setItem(this.idgoogle, 'profile_id');
      
        localStorage.setItem('profile_id', this.idgoogle);
        localStorage.setItem('authentication_token', this.user['user'].authentication_token);
        localStorage.setItem('token', this.user['user'].authentication_token);

        localStorage.setItem('role', '1');
   
        swal({
          background: "#FFFFFF",
          title: "success",
          html: `
            <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
              background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
              <div class="text-center" style="margin-top: 9%;">
                <img src="/assets/images/paraphrasing tool/success.svg" alt="Alert" />
                <div style="    width: 369px; height: 64px; margin-left: 39px;">
                  <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                  You have successfully logged into GrammarIn.
                  </p>
                </div>
              </div>
            </div>
          `,
          showConfirmButton: false,
          width: "323px",
          timer: 4000
        });



        setTimeout(() => {
          const okButton = document.getElementById('swal-ok-button');
          if (okButton) {
            okButton.addEventListener('click', () => {
              swal.close(); 
            });
          }
        }, 0);
       
        this.router.navigate(['/']).then(() => {
       
          window.location.reload();
        });


      } else if (data.meta.code === 400) {
      
        swal({
          background: "#FFFFFF",
          title: "Error",
          html: `
            <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
              background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
              <div class="text-center" style="margin-top: 9%;">
                <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                <div style="    width: 369px; height: 64px; margin-left: 39px;">
                  <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                   You have already registered your account from the web.
                  </p>
                </div>
                <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                  border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                  class="mt-5 butn-alert">Ok</button>
              </div>
            </div>
          `,
          showConfirmButton: false,
          width: "323px",
          timer: 4000
        });



        setTimeout(() => {
          const okButton = document.getElementById('swal-ok-button');
          if (okButton) {
            okButton.addEventListener('click', () => {
              swal.close();
            });
          }
        }, 0);
      }
    }, error => {
      // console.error('Login error', error);
    });
  }

  preventClose(event: Event) {
    event.stopPropagation(); 
  }






  activeMenu: string = '';

  setActiveMenu(menuItem: string): void {
    this.activeMenu = menuItem;
  }


  hover = false;


  onMouseEnter() {
    this.hover = true;
  }

  onMouseLeave() {
    this.hover = false;
  }

  navigatetoHome(): void {
    const mmElement = document.getElementById('mm');
    let editortxt = '';

    if (mmElement) {
      editortxt = mmElement.textContent || '';
      if (editortxt.trim()) {
    
        localStorage.removeItem('mm');
   
      } else {
      
      }
    } else {

    }

    this.router.navigate(['/']);

    const mmValue = localStorage.getItem('mm');
    if (mmValue) {

    } else {

    }
  }

}
